import { LOGIN_UNIFICADO } from "@/configs/runtime";
import FormularioEntrarGrupoFixoJwt from "./grupo-fixo/FormularioEntrarGrupoFixoJwt";
import FormularioEntrarUnificadoJwt from "./unificado/FormularioEntrarUnificadoJwt";

// --------------------------------- TYPES ---------------------------------
export type FormularioEntrarJwtProps = {
	readonly densidade?: "normal" | "compacta";
};

// ------------------------------- COMPONENT -------------------------------
export default function FormularioEntrarJwt({ densidade = "normal" }: Readonly<FormularioEntrarJwtProps>) {
	return LOGIN_UNIFICADO ? <FormularioEntrarUnificadoJwt densidade={densidade} /> : <FormularioEntrarGrupoFixoJwt />;
}
